/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { TagChangeDataOperationMethod } from './TagChangeDataOperationMethod';
import { TagChangeDataOperationMethodFromJSON, TagChangeDataOperationMethodFromJSONTyped, TagChangeDataOperationMethodToJSON, } from './TagChangeDataOperationMethod';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface TagChangeDataScatterplot
 *
 */
// create custom validators for the regexes
export interface TagChangeDataScatterplot {
    /**
     *
     * #type TagChangeDataOperationMethod
     * #memberof TagChangeDataScatterplot
        
        
         */
    method: TagChangeDataOperationMethod;
    /**
     *
     * #type string
     * #memberof TagChangeDataScatterplot
        
        
         */
    view?: string;
    /**
     *
     * #type number
     * #memberof TagChangeDataScatterplot
        
    * @minimum 0
            
         */
    count: number;
    /**
     *
     * #type number
     * #memberof TagChangeDataScatterplot
        
    * @minimum 0
            
         */
    added: number;
    /**
     *
     * #type number
     * #memberof TagChangeDataScatterplot
        
    * @minimum 0
            
         */
    removed: number;
}
/**
 * Check if a given object implements the TagChangeDataScatterplot interface.
 */
export function instanceOfTagChangeDataScatterplot(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "added" in value;
    isInstance = isInstance && "removed" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { TagChangeDataOperationMethodValidator, TagChangeDataOperationMethodStringifyShape, TagChangeDataOperationMethodStringifyShapeProperties, } from './TagChangeDataOperationMethod';
export const TagChangeDataScatterplotTypiaAssertEquals = (input: any) => {
    return ((input: any): TagChangeDataScatterplot => {
        const __is = (input: any, _exceptionable: boolean = true): input is TagChangeDataScatterplot => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => ("selected" === input.method || "added" === input.method || "removed" === input.method) && (undefined === input.view || "string" === typeof input.view) && ("number" === typeof input.count && 0 <= input.count) && ("number" === typeof input.added && 0 <= input.added) && ("number" === typeof input.removed && 0 <= input.removed) && (4 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["method", "view", "count", "added", "removed"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagChangeDataScatterplot => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("selected" === input.method || "added" === input.method || "removed" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"added\" | \"removed\" | \"selected\")",
                    value: input.method
                })) && (undefined === input.view || "string" === typeof input.view || $guard(_exceptionable, {
                    path: _path + ".view",
                    expected: "(string | undefined)",
                    value: input.view
                })) && ("number" === typeof input.count && (0 <= input.count || $guard(_exceptionable, {
                    path: _path + ".count",
                    expected: "number (@minimum 0)",
                    value: input.count
                })) || $guard(_exceptionable, {
                    path: _path + ".count",
                    expected: "number",
                    value: input.count
                })) && ("number" === typeof input.added && (0 <= input.added || $guard(_exceptionable, {
                    path: _path + ".added",
                    expected: "number (@minimum 0)",
                    value: input.added
                })) || $guard(_exceptionable, {
                    path: _path + ".added",
                    expected: "number",
                    value: input.added
                })) && ("number" === typeof input.removed && (0 <= input.removed || $guard(_exceptionable, {
                    path: _path + ".removed",
                    expected: "number (@minimum 0)",
                    value: input.removed
                })) || $guard(_exceptionable, {
                    path: _path + ".removed",
                    expected: "number",
                    value: input.removed
                })) && (4 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["method", "view", "count", "added", "removed"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataScatterplot",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataScatterplot",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const TagChangeDataScatterplotTypiaAssertStringify = (input: TagChangeDataScatterplot): string => {
    return ((input: any): string => { const assert = (input: any): TagChangeDataScatterplot => {
        const __is = (input: any): input is TagChangeDataScatterplot => {
            const $io0 = (input: any): boolean => ("selected" === input.method || "added" === input.method || "removed" === input.method) && (undefined === input.view || "string" === typeof input.view) && ("number" === typeof input.count && !Number.isNaN(input.count) && 0 <= input.count) && ("number" === typeof input.added && !Number.isNaN(input.added) && 0 <= input.added) && ("number" === typeof input.removed && !Number.isNaN(input.removed) && 0 <= input.removed);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagChangeDataScatterplot => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("selected" === input.method || "added" === input.method || "removed" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"added\" | \"removed\" | \"selected\")",
                    value: input.method
                })) && (undefined === input.view || "string" === typeof input.view || $guard(_exceptionable, {
                    path: _path + ".view",
                    expected: "(string | undefined)",
                    value: input.view
                })) && ("number" === typeof input.count && !Number.isNaN(input.count) && (0 <= input.count || $guard(_exceptionable, {
                    path: _path + ".count",
                    expected: "number (@minimum 0)",
                    value: input.count
                })) || $guard(_exceptionable, {
                    path: _path + ".count",
                    expected: "number",
                    value: input.count
                })) && ("number" === typeof input.added && !Number.isNaN(input.added) && (0 <= input.added || $guard(_exceptionable, {
                    path: _path + ".added",
                    expected: "number (@minimum 0)",
                    value: input.added
                })) || $guard(_exceptionable, {
                    path: _path + ".added",
                    expected: "number",
                    value: input.added
                })) && ("number" === typeof input.removed && !Number.isNaN(input.removed) && (0 <= input.removed || $guard(_exceptionable, {
                    path: _path + ".removed",
                    expected: "number (@minimum 0)",
                    value: input.removed
                })) || $guard(_exceptionable, {
                    path: _path + ".removed",
                    expected: "number",
                    value: input.removed
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataScatterplot",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataScatterplot",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: TagChangeDataScatterplot): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $so0 = (input: any): any => `{${undefined === input.view ? "" : `"view":${undefined !== input.view ? $string(input.view) : undefined},`}"method":${(() => {
            if ("string" === typeof input.method)
                return $string(input.method);
            if ("string" === typeof input.method)
                return "\"" + input.method + "\"";
            $throws({
                expected: "(\"added\" | \"removed\" | \"selected\")",
                value: input.method
            });
        })()},"count":${input.count},"added":${input.added},"removed":${input.removed}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const TagChangeDataScatterplotValidatorShape = {
    'method': TagChangeDataOperationMethodValidator.defined(),
    'view': yup.string(),
    'count': yup.number().min(0).defined(),
    'added': yup.number().min(0).defined(),
    'removed': yup.number().min(0).defined(),
};
export const TagChangeDataScatterplotValidator = yup.object().shape(TagChangeDataScatterplotValidatorShape);
export const TagChangeDataScatterplotStringifyShapeProperties: ObjectSchema['properties'] = {
    'method': TagChangeDataOperationMethodStringifyShape,
    'view': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'count': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'added': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'removed': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
};
export const TagChangeDataScatterplotStringifyShape: ObjectSchema = {
    title: 'TagChangeDataScatterplot Stringifier',
    type: 'object',
    properties: {
        ...TagChangeDataScatterplotStringifyShapeProperties
    },
    required: [
        'method',
        'count',
        'added',
        'removed',
    ],
};
export const TagChangeDataScatterplotStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(TagChangeDataScatterplotStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const TagChangeDataScatterplotStringify: (data: TagChangeDataScatterplot) => string = TagChangeDataScatterplotStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function TagChangeDataScatterplotFromJSON(json: any): TagChangeDataScatterplot {
    return TagChangeDataScatterplotFromJSONTyped(json, false);
}
export function TagChangeDataScatterplotFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagChangeDataScatterplot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'method': TagChangeDataOperationMethodFromJSON(json['method']),
        'view': !exists(json, 'view') ? undefined : json['view'],
        'count': json['count'],
        'added': json['added'],
        'removed': json['removed'],
    };
}
export function TagChangeDataScatterplotToJSON(value?: TagChangeDataScatterplot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'method': TagChangeDataOperationMethodToJSON(value.method),
        'view': value.view,
        'count': value.count,
        'added': value.added,
        'removed': value.removed,
    };
}
